/**
 * PROTOTYPE CONTENT — NOT VERIFIED. Restored verbatim from `design-reference/`.
 * None of these announcements happened. See CONTENT-STATUS.md.
 */
export interface NewsItem {
  date: string
  /** Short category chip: Company, Award, Safety, and so on. */
  tag: string
  title: string
  body: string
  /** Thumbnail on the news page. */
  image: string
}

export const news: NewsItem[] = [
  {
    date: '05 Aug 2026',
    tag: 'Company',
    title: 'Order book reaches R48 million across six contracts',
    body: 'Six months after registration, Samloryx is working in three provinces with a headcount of 41 and a sixth contract out to tender.',
    image: '/images/news-1.jpg',
  },
  {
    date: '19 Jul 2026',
    tag: 'Award',
    title: 'First mining contract awarded — Emalahleni access road rehabilitation',
    body: 'A R11.4 m appointment to rebuild 6.2 km of mine access road to 40 t axle loading, with site handover scheduled for October.',
    image: '/images/news-2.jpg',
  },
  {
    date: '28 Jun 2026',
    tag: 'Safety',
    title: 'One hundred days on site without a lost-time injury',
    body: 'Across two active sites and 46 000 worked hours, no lost-time or reportable incidents have been recorded since the company opened.',
    image: '/images/news-3.jpg',
  },
  {
    date: '14 May 2026',
    tag: 'Company',
    title: 'CIDB Grade 6CE and 6GB PE registration confirmed',
    body: 'The grading, awarded on financial capability under potentially-emerging status, allows contracts up to R13 million. Grade 7 is the target for 2027.',
    image: '/images/news-4.jpg',
  },
]
